import React from 'react';

import HeaderSectionLoading from '../components/HeaderSectionLoading';
import TopSimpleSection from '../components/TopSimpleSection';
import TopMenu from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import Back2TopBtn from '../components/Back2TopBtn';
/* import Footer from '../components/Footer';
import WBkey from '../components/WBkey';
import Subscribe from '../components/Subscribe'; */

export default function AboutLayoutLoading(props) {
	const {
		title,
		subtitle,
		backgroundImage,
		children,
		search,
		collection,
		collage,
	} = props;
	//return <div>Loading</div>;
	return (
		<div className='c-main-wrapper'>
			<TopMenu background='white' />
			<TopSimpleSection
				loading
				backgroundImage={backgroundImage}
				search={search}
			/>
			{collection && (
				<HeaderSectionLoading
					title={title}
					subtitle={subtitle}
					colection
				/>
			)}
			{collage && <HeaderSectionLoading subtitle={subtitle} collage />}
			{/* {button && news && (
				<HeaderSectionLoading
					title={title}
					subtitle={subtitle}
					button
					news
				/>
			)}
			{!button && (
				<HeaderSectionLoading title={title} subtitle={subtitle} />
			)} */}

			{children}
			<Back2TopBtn/>
			<Footer />
		</div>
	);
}
